/**
 * created by li si yi
 * 微信稿件待办处理
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import BaseComponent from "../../../../../base/BaseComponent";

class ReceiveEditor extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};
    getReceiveIds = (data) => {
        let ids = [];
        if (data.activitiCategoryKey === "tggj") {
            if (data.data && data.data.mediaIds && (data.data.mediaIds instanceof Array) && (data.data.mediaIds.length > 0)) {
                ids.push(data.data.id);
            }
        }
        return ids;
    };

    isSupport(data) {
        // console.log('稿件与网站稿件111111111111', data);
        this.data = data;
        let receiveIds = this.getReceiveIds(this.data);
        if (this.data && this.data.data && this.data.data.id && this.data.activitiCategoryKey === "likeWechat") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'ContributeIcon';
        return icon
    };
    handle = (data, call) => {
        window.openEditById({
            configName: data.data.openEditorStyle ? data.data.openEditorStyle : "receiveEditor",
            id: data.data.id
        });
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                call && call();
            }
        }, "ManuscriptsSubmitted")
    };

    render() {
        return (
            <div style={{display: 'none'}}>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(ReceiveEditor)